/**
 * These free products aren't owned by any customers. Some of these products don't even exist in Merchandise.
 * These are placeholders used by non-Fintech teams to refer to the free version of products, for example in FeatureStore.
 */
export const FreeProducts = {
  CMS_HUB_FREE: 'cms-hub-free',
  COMMERCE_HUB_FREE: 'commerce-hub-free',
  HUBSPOT_FREE: 'hubspot-free',
  MARKETING_HUB_FREE: 'marketing-hub-free',
  OPERATIONS_HUB_FREE: 'operations-hub-free',
  SALES_HUB_FREE: 'sales-hub-free',
  SERVICE_HUB_FREE: 'service-hub-free'
};
export default FreeProducts;